export enum NotifyDeveloperRequest {
    TestMessageNotReceived = 'TestMessageNotReceived',
    TestMessageNeedHelp = 'TestMessageNeedHelp',
    RequestGPT3Contents = 'RequestGPT3Contents',
    ChannelIntegration = 'ChannelIntegration',
}

export interface NotifyDeveloperRequestModel {
    request_code: NotifyDeveloperRequest;
    metadata?: Record<any, any>;
}
